// @flow
// Pure view-model selectors for the embed page. Each takes the shaped API
// payload (see utils/api.shapePropertyResponse) plus the active tab index and
// returns the props one card needs, tolerating partial or missing data.

export const improvementCardData = (data: any, currentTab: number) => {
  const result = {
    title: '',
    description: '',
    profitable: '',
    greenImprovementValue: 0,
  };
  if (data && data.profilt) {
    if (data.profilt[currentTab] && data.profilt[currentTab].ShortText) {
      result.title = data.profilt[currentTab].ShortText;
    }

    if (data.profilt[currentTab] && data.profilt[currentTab].profitable) {
      result.profitable = data.profilt[currentTab].profitable;
    }

    if (data.profilt[currentTab] && data.profilt[currentTab].LongText) {
      result.description = data.profilt[currentTab].LongText;
    }

    if (
      data.profilt[currentTab] &&
      data.profilt[currentTab]._greenImprovementValue
    ) {
      result.greenImprovementValue =
        data.profilt[currentTab]._greenImprovementValue;
    }
  }
  return result;
};

export const treeCardData = (data: any, currentTab: number) => {
  const result = {
    CO2Saving: '',
  };

  if (data && data.profilt) {
    if (data.profilt[currentTab] && data.profilt[currentTab].CO2Saving) {
      result.CO2Saving = parseFloat(data.profilt[currentTab].CO2Saving).toFixed(
        2
      );
    }
  }
  return result;
};

export const moneyBagData = (data: any, currentTab: number) => {
  const result = {
    MoneySaving: '',
    Investment: '',
  };

  if (data && data.profilt) {
    if (data.profilt[currentTab] && data.profilt[currentTab].MoneySaving) {
      result.MoneySaving = parseInt(data.profilt[currentTab].MoneySaving, 10);
    }

    if (data.profilt[currentTab] && data.profilt[currentTab].Investment) {
      result.Investment = parseInt(data.profilt[currentTab].Investment, 10);
    }
  }
  return result;
};

export const isAllImprovementTab = (data: any, currentTab: number) => {
  let result = false;
  if (
    data &&
    data.profilt &&
    data.profilt[currentTab] &&
    data.profilt[currentTab]._isAllTab === true
  ) {
    result = true;
  }
  return result;
};

export const isAllTabProfitable = (data: any, currentTab: number) => {
  let result = false;
  if (
    data &&
    data.profilt &&
    data.profilt[currentTab] &&
    data.profilt[currentTab].profitable === 'true'
  ) {
    result = true;
  }
  return result;
};
